/**
 * Merges fetched translations without namespaces into default translations with namespaces.
 * This function combines the fetched translations with the default translations, taking into account
 * the existence of corresponding keys in both sets of translations.
 *
 * @typeParam T Type representing translations with namespaces.
 * @param defaultTranslationsWithNamespaces An object containing translations organized by
 * namespaces. The keys of this object represent the namespaces, and the values are objects containing
 * key-value pairs of translations.
 * @param fetchedTranslationsWithoutNamespaces An object containing translations
 * without namespaces. Each key represents a translation key, and the value represents the translated
 * value.
 * @returns Merged translations with namespaces.
 */
export const mergeTranslations = (defaultTranslationsWithNamespaces, fetchedTranslationsWithoutNamespaces) => {
  const output = {};
  for (const namespace in defaultTranslationsWithNamespaces) {
    if (Object.hasOwn(defaultTranslationsWithNamespaces, namespace)) {
      const translations = {};
      const currentNamespaceTranslations = defaultTranslationsWithNamespaces[namespace];
      if (currentNamespaceTranslations) {
        for (const key in currentNamespaceTranslations) {
          if (Object.hasOwn(currentNamespaceTranslations, key)) {
            const defaultValue = currentNamespaceTranslations[key];
            const translatedValue = fetchedTranslationsWithoutNamespaces[key];
            if (translatedValue !== undefined) {
              translations[key] = translatedValue;
            } else if (defaultValue !== undefined) {
              translations[key] = defaultValue;
            }
          }
        }
        output[namespace] = translations;
      }
    }
  }
  return output;
};
//# sourceMappingURL=mergeTranslations.js.map